"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var PageInfo = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(PageInfo, _Component);

  var _super = _createSuper(PageInfo);

  function PageInfo(props) {
    var _this;

    (0, _classCallCheck2.default)(this, PageInfo);
    _this = _super.call(this, props);
    _this.state = {
      isValid: true
    };
    _this.validate = _this.validate.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(PageInfo, [{
    key: "validate",
    value: function validate(page, totalPages, callback) {
      var isValid = page > 0 && page <= totalPages;
      this.setState({
        isValid: isValid
      });
      if (page && isValid) callback(page);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = this.props;
      var state = this.state;
      var totalPages = props.totalPages,
          currentPage = props.currentPage,
          onPageChange = props.onPageChange;
      var isValid = state.isValid;
      return (0, _preact.h)("div", {
        className: "control-pagination--pager-item"
      }, (0, _preact.h)("span", null, "Page", (0, _preact.h)("input", {
        className: "control-pagination--current-page ".concat(!isValid ? 'invalid' : ''),
        type: 'text',
        value: currentPage,
        onChange: function onChange(e) {
          var page = parseInt(e.target.value);

          _this2.validate(page, totalPages, onPageChange);
        }
      }), "of ", (0, _preact.h)("strong", null, totalPages)));
    }
  }]);
  return PageInfo;
}(_preact.Component);

var _default = PageInfo;
exports.default = _default;